<template>
	<div class="fixed inset-0 bg-black/50 flex items-center justify-center z-[100]" @click.self="$emit('close')">
		<div class="bg-white rounded-lg shadow-xl w-full max-w-2xl mx-4 max-h-[90vh] overflow-y-auto" @click.stop>
			<!-- Header -->
			<div class="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
				<h5 class="text-xl font-semibold text-gray-900 tracking-wide">Bulk Screenshot Generation</h5>
				<button @click="$emit('close')" class="text-gray-400 hover:text-gray-600 transition-colors">
					<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
					</svg>
				</button>
			</div>

			<!-- Content -->
			<div class="px-6 py-6">
				<!-- Options -->
				<div class="space-y-4">
					<label class="flex items-center gap-3 cursor-pointer">
						<input type="radio" v-model="mode" value="all" class="rounded-full border-gray-300 text-black focus:ring-black">
						<span class="text-sm font-medium text-gray-900">Generate all lot screenshots</span>
					</label>
					<label class="flex items-center gap-3 cursor-pointer">
						<input type="radio" v-model="mode" value="missing" class="rounded-full border-gray-300 text-black focus:ring-black">
						<span class="text-sm font-medium text-gray-900">Generate only lots without screenshots</span>
					</label>
				</div>

				<!-- Count Display -->
				<div class="mt-6 text-sm text-gray-600">
					<span v-if="filteredLots.length === 0">No lots to process.</span>
					<span v-else>{{ filteredLots.length }} {{ filteredLots.length === 1 ? 'lot' : 'lots' }} will be processed.</span>
				</div>
			</div>

			<!-- Footer Actions -->
			<div class="sticky bottom-0 bg-gray-50 px-6 py-4 flex justify-end gap-3 border-t border-gray-200">
				<button
					@click="$emit('close')"
					class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
				>
					Cancel
				</button>
				<button
					@click="handleStart"
					:disabled="filteredLots.length === 0"
					class="px-4 py-2 text-sm font-medium text-white bg-gray-900 rounded-md hover:bg-gray-800 transition-colors disabled:opacity-50"
				>
					Start
				</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ScreenshotBulkModal',
	props: {
		entries: {
			type: Array,
			default: () => []
		}
	},
	emits: ['close'],
	data() {
		return {
			mode: 'missing'
		}
	},
	computed: {
		filteredLots() {
			if (!this.entries || !Array.isArray(this.entries)) return []
			const entries = this.entries.filter(e => e.title)
			if (this.mode === 'all') return entries.map(e => e.title)
			// Only lots without screenshot
			return entries.filter(e => {
				const hasScreenshot = e.screenshot && (Array.isArray(e.screenshot) ? e.screenshot.length > 0 : !!e.screenshot)
				return !hasScreenshot
			}).map(e => e.title)
		}
	},
	methods: {
		handleStart() {
			const lots = this.filteredLots
			if (lots.length === 0) return
			const first = lots[0]
			const remaining = lots.slice(1).join(',')
			const total = lots.length
			const params = new URLSearchParams({
				lot: first,
				screenshot: 'true',
				total: String(total)
			})
			if (remaining) params.set('remaining', remaining)
			window.location.href = '/map?' + params.toString()
		}
	}
}
</script>
